import styled from 'styled-components';

export const RoleSelectorContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const RoleSelectorButton = styled.button<{ isOpen: boolean }>`
  width: 153px;
  height: 32px;
  background-color: #A0D6FF;
  color: #0066B3;
  border: none;
  border-radius: 4px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-style: bold;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  transition: all 0.2s ease;

  &:hover {
    background-color: #8BC9FF;
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }

  span {
    flex: 1;
    text-align: center;
  }
`;

export const RoleSelectorDropdown = styled.div`
  position: absolute;
  top: 36px;
  left: 0;
  width: 309px;
  background: white;
  border-radius: 4px;
  padding: 8px;
  z-index: 1000;
  border: 1px solid #E5E7EB;
`;

export const RoleOption = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  text-align: left;

  &:hover {
    background-color: #F3F4F6;
  }

  ${({ isSelected }) => isSelected && `
    background-color: #EBF8FF;
  `}
`;

export const RoleText = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-style: medium;
  font-size: 14px;
  leading-trim: none;
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #464646;
  text-align: left;
`;

export const RoleDescription = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-style: medium;
  font-size: 12px;
  leading-trim: none;
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #464646;
  margin-top: 2px;
  text-align: left;
`;

export const OptionSeparator = styled.div`
  border-top: 1px solid #C4C5C6;
  margin: 4px 0;
`;

export const CheckIcon = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding-bottom: 0px;
  margin-top: 18px;
`;
